import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";

class TextControlViewModel extends BaseViewModel {

	MaxLength: number = 255;
	MinLength: number = 0;
	Mask?: string;
	Pinput?: string;
	regexp?: RegExp;

	constructor ( params: BaseViewModelParams ) {
		super( params );
		this.Mask = params.elementDescriptor.Mask;
		this.Pinput = '';
		this.Tooltip = params.elementDescriptor.Tooltip;
		if ( params.elementDescriptor.Pinput !== null ) {
			let regul = "[";
			if ( params.elementDescriptor?.Pinput?.indexOf('Digit') !== -1 )
				regul += '0-9';
			if ( params.elementDescriptor?.Pinput?.indexOf('Latin') !== -1 )
				regul += 'A-Za-z';
			if ( params.elementDescriptor?.Pinput?.indexOf('Cyrilic') !== -1 )
				regul += 'А-Яа-яЁё';
			if ( params.elementDescriptor?.Pinput?.indexOf('Space') !== -1 )
				regul += ' ';
			if ( params.elementDescriptor?.Pinput?.indexOf('Special') !== -1 )
				// eslint-disable-next-line
				regul += '\\/~"@$!#,%\\^\'&\\*\\(\\)\\[\\]{}\\+=_;:<>№\\|\\?\\\\\\.\\-';
			regul += ']+';

			//Ограничение ввода, если описатель об этом говорит
			this.regexp = new RegExp(regul, 'g');
			this.Pinput = regul;
		}
		if ( params.elementDescriptor.MaxLength != null && params.elementDescriptor.MaxLength !== 0 ) {
			this.MaxLength = params.elementDescriptor.MaxLength;
		}
		else {
			this.MaxLength = params.elementDescriptor.ControlKey === "MultiStringText" ? 1024 : 255;
		}
		if ( params.elementDescriptor.MinLength !== null && params.elementDescriptor.MinLength !== 0 ) {
			this.MinLength = params.elementDescriptor.MinLength;
		}
	};

	override getValue = () => this.Value ?? "";

	ValidateMandatory = () => {
		const mandatoryResult = !this.IsMandatory;
		const value = this.getValue();
		const hasSymbols = value !== undefined && value !== null && value !== '';
		const baseResult = mandatoryResult || hasSymbols;
		if ( this.MinLength > 0 ) {
			if ( hasSymbols && value.length < this.MinLength ) {
				return false;
			}
		}
		if ( this.MaxLength > 0 ) {
			if ( hasSymbols && value.length > this.MaxLength ) {
				return false;
			}
		}
		return baseResult;
	};

	getSimpleFormatXmlOpen = () => {
		let xml = '<' + this.getSimpleFormatXmlTagName() + ' idRef="' + this.LocalPath + '" title="' + this.elementDescriptor.Caption + '" ';
		if ( this.IsMandatory )
			xml += 'isRequired="true" ';
		if ( this.elementDescriptor.ControlKey === "MultiStringText" )
			xml += 'isMultiString="true"';
		return xml + '>';
	};

};

export default TextControlViewModel;
